import { useEffect, useState } from "react";
import Title from "../../../components/common/title/Title";
import { getApi } from "../../../services/api/globalApi";
import { digitsThree } from "../../../utils/price";
import OrdersReportsFilter from "./OrdersReportsFilter";

export default function OrdersReports() {
  const [reportsData, setReportsData] = useState(null);

  const getOrdersReports = async (params) => {
    const path = "/admin/reports/getOrderSalesPriceReport";
    try {
      const response = await getApi({ path, params: { ...params } });
      setReportsData(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOrdersReports({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getOrdersReports(allFilter);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"گزارش سفارشات"} />
      <OrdersReportsFilter filterDataHandler={filterDataHandler} />
      <div className="w-full flex-wrap flex justify-center items-cneter gap-4">
        <div className="px-14 py-6 rounded-xl text-white bg-blue-600 flex items-center justify-center flex-col gap-4">
          <p>تعداد فروش</p>
          <span> {reportsData?.count}</span>
        </div>
        <div className="px-14 py-6 rounded-xl text-white bg-green-600 flex items-center justify-center flex-col gap-4">
          <p>فروش خالص</p>
          <span> {digitsThree(reportsData?.foroshKhales)}</span>
        </div>
        <div className="px-14 py-6 rounded-xl text-white bg-purple-600 flex items-center justify-center flex-col gap-4">
          <p>فروش ناخالص</p>
          <span> {digitsThree(reportsData?.foroshNaKhales)}</span>
        </div>
      </div>
    </div>
  );
}
